import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../utils/hooks/useMutationWithError";
import { useUpdateLanguagePreferenceMutation } from "./__generated__/useUpdateLanguagePreferenceMutation.graphql";

export const useUpdateLanguagePreference = () =>
  useMutationWithError<useUpdateLanguagePreferenceMutation>(
    useUpdateLanguagePreferenceMutationString
  );

const useUpdateLanguagePreferenceMutationString = graphql`
  mutation useUpdateLanguagePreferenceMutation($input: UpdateMemberUserInput!) {
    responsePayload: updateMemberUser(input: $input) {
      user {
        id
        preferredLocale
      }
      success
      errors {
        code
        field
        message
      }
    }
  }
`;
